import { PAGINATION_ALL_ITEMS_SIZE } from '../../../../constants/pagination'

export const ASYNC_SELECT_LOAD_ALL_PAGE_SIZE_PARAMS = {
  page_size: PAGINATION_ALL_ITEMS_SIZE,
}

export const ASYNC_SELECT_LOAD_ALL_IDWELL_API_PAGE_SIZE_PARAMS = {
  size: PAGINATION_ALL_ITEMS_SIZE,
}

export const ASYNC_SELECT_LOAD_NEXT_THRESHOLD_END_INDEX = 1

export const MIN_SEARCH_SELECT_LENGTH = 0
